import { render, staticRenderFns } from "./ConfigEmailContacts.vue?vue&type=template&id=d2e6b2e4"
import script from "./ConfigEmailContacts.vue?vue&type=script&lang=js"
export * from "./ConfigEmailContacts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports